import { useSyncExternalStore } from 'react'
import type { RefObject } from 'react'
import type { AgGridReact } from 'ag-grid-react'

export type ActiveGridSnapshot = {
  scopeKey: string
  gridRef: RefObject<AgGridReact | null>
  gridIsReady: boolean
}

type Listener = () => void

let activeGrid: ActiveGridSnapshot | null = null
const listeners = new Set<Listener>()

const emit = () => {
  listeners.forEach((listener) => {
    try {
      listener()
    } catch {
      // ignore listener errors
    }
  })
}

export const setActiveGrid = (next: ActiveGridSnapshot | null) => {
  activeGrid = next
  emit()
}

export const clearActiveGrid = (scopeKey?: string) => {
  if (!activeGrid) return
  if (scopeKey && activeGrid.scopeKey !== scopeKey) return
  setActiveGrid(null)
}

export const getActiveGrid = () => activeGrid

export const subscribeActiveGrid = (listener: Listener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export const useActiveGrid = () => {
  return useSyncExternalStore(subscribeActiveGrid, getActiveGrid, () => null)
}
